import { useCallback, useEffect, useState } from "react";
import {
  Typography,
  Box,
  Card,
  Stack,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Postrequestcall } from "../../request/Postrequest";
import { FETCH_REWARD_ACTIVITIES, GET_NEW_QUESTION_FOR_THE_USER } from "../../constant/Apipath";
import { Getrequestcall } from "../../request/Getrequest";
import { useSelector } from "react-redux";
import Loader from "../../common/Loader";
import { English } from "../../constant/EnglishFallback";
import { ArrowForwardIos } from "@mui/icons-material";
import bucksIcon from "../../assets/images/bucks.png";
import { BIBlue } from "../../assets/helpers";
import { TEXT } from "react-dnd-html5-backend/dist/NativeTypes";

const EarnBuilderBucks = () => {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  // const userId = loginData?.userInformation?.UserId;
  // const [isEarnRewardsAvailable, setIsEarnRewardsAvailable] = useState(false);
  const [rewardActivity, setRewardActivity] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const LanguageData = multiLanguageData?.RewardStore || {};
  const {
    TEXT_FOOTER_NOTE = English.RewardStore.TEXT_FOOTER_NOTE,
    TEXT_ANS_QUESTIONS = English.RewardStore.TEXT_ANS_QUESTIONS,

    TEXT_FIRST_LIST_ITEM_SUBHEADING = English.RewardStore.TEXT_FIRST_LIST_ITEM_SUBHEADING,
    TEXT_ADD_NEW_CONSTRUCTION_SITE = English.RewardStore.TEXT_ADD_NEW_CONSTRUCTION_SITE,
    TEXT_SECOND_LIST_ITEM_SUBHEADING = English.RewardStore.TEXT_SECOND_LIST_ITEM_SUBHEADING,
    TEXT_ADD_NEW_COMPANIES = English.RewardStore.TEXT_ADD_NEW_COMPANIES,
    TEXT_THIRD_LIST_ITEM_SUBHEADING = English.RewardStore.TEXT_THIRD_LIST_ITEM_SUBHEADING,
    TEXT_SUBMIT_PRODUCTS = English.RewardStore.TEXT_SUBMIT_PRODUCTS,
    TEXT_FOUR_LIST_ITEM_SUBHEADING = English.RewardStore.TEXT_FOUR_LIST_ITEM_SUBHEADING,
    TEXT_CONNECT_OTHER_BUILDERS = English.RewardStore.TEXT_CONNECT_OTHER_BUILDERS,
    TEXT_FIVE_LIST_ITEM_SUBHEADING = English.RewardStore.TEXT_FIVE_LIST_ITEM_SUBHEADING,
    TEXT_SIX_LIST_ITEM_SUBHEADING = English.RewardStore.TEXT_SIX_LIST_ITEM_SUBHEADING,
    TEXT_REPORT_INCORRECT_INFORMATION = English.RewardStore.TEXT_REPORT_INCORRECT_INFORMATION,
    TEXT_VARIES = English.RewardStore.TEXT_VARIES,
  } = LanguageData || {};

  const navigate = useNavigate();

  const updateRewardActivities = useCallback(async () => {
    try {
      const res = await Postrequestcall(
        FETCH_REWARD_ACTIVITIES,
        { SearchList: [{ createdBy: 0 }] },
        loginData?.accessToken
      );

      let rewardActivityData = [];
      if (res?.data?.data?.length > 0) {
        res?.data?.data.forEach((rewardActivity) => {
          rewardActivityData.push({
            id: rewardActivity.id || 0,
            bucks: rewardActivity.bucks || 0
          });
        });
      }
      setRewardActivity(rewardActivityData);
    } catch (error) {
      console.error("updateRewardActivities-> Error fetching reward activities: ", error);
    }
  }, [loginData?.accessToken]);

  // const getNewQuestionListForTheUser = useCallback(
  //   async (type) => {
  //     const userRewardUrl = `${GET_NEW_QUESTION_FOR_THE_USER}/${userId}`;
  //     try {
  //       setIsLoading(true);
  //       const question = await Getrequestcall(userRewardUrl, loginData?.accessToken);
  //       setIsLoading(false);

  //       setIsEarnRewardsAvailable(!question?.data?.data);
  //     } catch (error) {
  //       console.error("getNewQuestionListForTheUser-> Error fetching location: ", error);
  //     }
  //   },
  //   [userId, loginData?.accessToken]
  // );

  // useEffect(() => {
  //   getNewQuestionListForTheUser();
  // }, [getNewQuestionListForTheUser]);

  useEffect(() => {
    updateRewardActivities();
  }, [updateRewardActivities]);

  const getBucks = (activityId) => {
    const data = rewardActivity.filter((buck) => buck.id === activityId);
    return data[0]?.bucks;
  };

  const cardData = [
    {
      title: TEXT_ANS_QUESTIONS,
      description: TEXT_FIRST_LIST_ITEM_SUBHEADING,
      action: () => navigate("/reward-store/earn-builderbucks/earn-rewards"),
      bucks: TEXT_VARIES
    },
    {
      title: TEXT_ADD_NEW_CONSTRUCTION_SITE,
      description: TEXT_SECOND_LIST_ITEM_SUBHEADING,
      action: () => navigate("/sites"),
      bucks: getBucks(32)
    },
    {
      title: TEXT_ADD_NEW_COMPANIES,
      description: TEXT_THIRD_LIST_ITEM_SUBHEADING,
      action: () => navigate("/companies"),
      bucks: getBucks(13)
    },
    {
      title: TEXT_SUBMIT_PRODUCTS,
      description: TEXT_FOUR_LIST_ITEM_SUBHEADING,
      action: () => navigate("/products"),
      bucks: getBucks(1)
    },
    {
      title: TEXT_CONNECT_OTHER_BUILDERS,
      description: TEXT_FIVE_LIST_ITEM_SUBHEADING,
      action: () => navigate("/contacts"),
      bucks: getBucks(21)
    },
    {
      title: TEXT_REPORT_INCORRECT_INFORMATION,
      description: TEXT_SIX_LIST_ITEM_SUBHEADING,
      bucks: getBucks(22)
    },
  ];

  const EarnCard = (props) => {
    return (
      <Card
        sx={{
          borderRadius: 2,
          p: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          minWidth: 300,
          border: "1px solid #e0e0e0",
          boxShadow: 1,
          cursor: props?.card?.action ? "pointer" : "default",
        }}
        onClick={props?.card?.action ? props?.card?.action : null}
      >
        {/* Left Section */}
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="subtitle1" fontWeight="600" sx={{ mb: 0.5 }}>
            {props?.card?.title}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.5 }}>
            {props?.card?.description}
          </Typography>
        </Box>

        {/* Right Section */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#f0f4f8",
              borderRadius: 2,
              px: 1.2,
              py: 0.5,
              mr: 1.5,
              minWidth: 60,
              justifyContent: "center",
              gap: 0.5,
            }}
          >
            <Typography
              variant="body2"
              fontWeight={600}
              sx={{ color: BIBlue }}
            >
              {props?.card?.bucks}
            </Typography>
            <Box
              component="img"
              src={bucksIcon || ""}
              alt="bucks"
              sx={{ width: 20, height: 25 }}
            />
          </Box>


          {props?.card?.action ? <IconButton size="small" sx={{ color: BIBlue, cursor: props?.card?.action ? "pointer" : "default" }}>
            <ArrowForwardIos fontSize="small" />
          </IconButton> : null}
        </Box>
      </Card>
    );
  };

  return (
    <>
      <Box className="main-content-card-list">
        {isLoading ? (
          <Loader />
        ) : (
          <Stack spacing={1}>
            {
              cardData.map((card, index) => (
                <EarnCard key={index} card={card} />
              ))
            }

          </Stack>
        )}
      </Box>
      <Typography variant="body1" width={"100%"} textAlign={"center"} pt={1}>
        {TEXT_FOOTER_NOTE}
      </Typography>
    </>
  );
};

export default EarnBuilderBucks;
